import { Routes, Route, Navigate } from 'react-router-dom';
import {
  AdminDashboardPage,
  AdminOrdersPage,
  AdminLeadsPage,
  AdminInventoryPage,
  AdminUsersPage,
  AdminSettingsPage,
  AdminDocumentsPage,
  ProfilePage,
  AdminLoginPage,
} from './pages';
import { AdminLayout } from './components/admin/AdminLayout';
import { isAuthenticated } from './services/auth';
import './styles/globals.css';

function RequireAdmin({ children }: { children: JSX.Element }) {
  if (!isAuthenticated()) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}

// The app is admin-only: customers order through the standalone landing
// (lablanding), so every public storefront route was removed and the root
// simply forwards to the admin panel.
function App() {
  return (
    <div className="app">
      <main>
        <Routes>
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminLayout />
              </RequireAdmin>
            }
          >
            <Route index element={<AdminDashboardPage />} />
            <Route path="orders" element={<AdminOrdersPage />} />
            <Route path="leads" element={<AdminLeadsPage />} />
            <Route path="inventory" element={<AdminInventoryPage />} />
            <Route path="users" element={<AdminUsersPage />} />
            <Route path="settings" element={<AdminSettingsPage />} />
            <Route path="documents" element={<AdminDocumentsPage />} />
            <Route path="profile" element={<ProfilePage />} />
          </Route>

          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
